import React, { memo } from 'react';
import Calendar from 'react-date-range/dist/components/Calendar';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultWeekStartsOn, defaultWeekdayDisplayFormat } from './constants';
import { defaultMaxDate, defaultMinDate } from './defaultDate';
import { mainTheme } from '@plecto/ui';

const S = {};
S.Calendar = styled(Calendar)`
	// react-date-range ships a light stylesheet; these repoint the surface it paints.
	&,
	.rdrMonth,
	.rdrMonths,
	.rdrDay,
	.rdrMonthAndYearWrapper,
	.rdrDateDisplayWrapper {
		background: transparent;
		color: ${mainTheme.text.primary};
	}
	.rdrWeekDay {
		color: ${mainTheme.text.tertiary};
	}
	.rdrDayNumber span {
		color: ${mainTheme.text.primary};
	}
	.rdrDayPassive .rdrDayNumber span,
	.rdrDayDisabled .rdrDayNumber span {
		color: ${mainTheme.text.disabled};
	}
	.rdrDayDisabled {
		background: transparent;
	}
	.rdrMonthAndYearPickers select {
		color: ${mainTheme.text.primary};

		option {
			background: ${mainTheme.form.dropdown.menu.default};
		}
	}
	.rdrNextPrevButton {
		background: ${mainTheme.form.dropdown.menu.hover.background};
	}
	.rdrSelected {
		background-color: ${mainTheme.fill.brand};
		position: absolute;
		top: 0;
		left: 0px;
		right: 0px;
		bottom: 0px;
		pointer-events: none;
		border: 0px solid currentColor;
		z-index: 1;
		border-radius: 50%;
	}
	.rdrDay:not(.rdrDayPassive) .rdrSelected ~ .rdrDayNumber span {
		color: ${mainTheme.text.inverted};
		z-index: 2;
	}
	.rdrDay:not(.rdrSelected):hover {
		background-color: ${mainTheme.form.dropdown.menu.hover.background};
		box-sizing: border-box;
		z-index: 1;
		border: 2px solid ${mainTheme.border.brand};
		border-radius: 50%;
	}
	.rdrDayToday .rdrDayNumber:not(:only-child) span:after {
		content: none;
	}
	.rdrMonthPicker select {
		background-position: right 12px top calc(50% + 1px);
	}	
	.rdrYearPicker select {
		background-position: right 4px top calc(50% + 1px);
	}
`;

function DatePicker({
	date,
	onDateChange,
	showPreview = false,
	weekStartsOn = defaultWeekStartsOn,
	minDate = defaultMinDate,
	maxDate = defaultMaxDate,
	weekdayDisplayFormat = defaultWeekdayDisplayFormat,
}) {
	return <S.Calendar
		date={date}
		onChange={onDateChange}
		showPreview={showPreview}
		weekStartsOn={weekStartsOn}
		minDate={minDate}
		maxDate={maxDate}
		weekdayDisplayFormat={weekdayDisplayFormat}
	/>;
}

DatePicker.propTypes = {
	date: PropTypes.instanceOf(Date).isRequired,
	onDateChange: PropTypes.func.isRequired,
	minDate: PropTypes.instanceOf(Date),
	maxDate: PropTypes.instanceOf(Date),
	weekdayDisplayFormat: PropTypes.string,
	weekStartsOn: PropTypes.number,
};

export default memo(DatePicker);
